import types from '../../constants';

const initialState = {
  loading: false,
  loadingCompanies: false,
  companies: [],
  data: [],
  filter: {
    name: '',
    company: '',
  },
};

const UsersReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.USERS_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case types.USERS_FETCH_END:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case types.COMPANIES_FETCH_START:
      return {
        ...state,
        loadingCompanies: true,
      };
    case types.COMPANIES_FETCH_END:
      return {
        ...state,
        companies: action.payload,
        loadingCompanies: false,
      };
    case types.USERS_CHANGE_FILTER:
      const newFilter = { ...state.filter };
      const { key, value } = action.payload;
      newFilter[key] = value;

      return {
        ...state,
        filter: newFilter,
      };
    case types.USERS_RESET_FILTER:
      return {
        ...state,
        filter: {},
      };
    default:
      return state;
  }
};

export default UsersReducers;
